<template>
    <div>
        <form @submit.prevent class="mt-4">

            <div class="row">
                <div class="col-sm-12  mt-4 mb-3">
                    <div class="text-xl text-grey-darkest mr-2 mb-2 mb-lg-0 block lg:inline w-full lg:w-auto">Project Information</div>
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="id">ID</label>
                    <input v-model="form.project_id" type="text" name="id" id="id"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="name">Project Name</label>
                    <input v-model="form.project_name" type="text" name="name" id="name"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="address">Address</label>
                    <input v-model="form.address" type="text" size="50" name="address" id="address"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="city">City</label>
                    <input v-model="form.city" type="text" name="city" id="city"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="state">State</label>
                    <input v-model="form.state" type="text" name="state" id="state"
                           maxlength="2"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="zip">Zip</label>
                    <input v-model="form.zip" type="text" name="zip" id="zip"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="contact_name">Contact Name</label>
                    <input v-model="form.contact_name" type="text" name="contact_name" id="contact_name"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1"
                           autocomplete="off">
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="contact_email">Contact Email</label>
                    <input v-model="form.contact_email" type="text" name="contact_email" id="contact_email"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="contact_phone">Contact Phone</label>
                    <input v-model="form.contact_phone" type="text" name="contact_phone"
                           v-mask="['(###) ###-####', '(###) ###-#### ext. ####']"
                           id="contact_phone"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="contact_cell">Contact Cell</label>
                    <input v-model="form.contact_cell" type="text" name="contact_cell" id="contact_cell"
                           v-mask="['(###) ###-####', '(###) ###-#### ext. ####']"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="contact_fax">Contact Fax</label>
                    <input v-model="form.contact_fax" type="text" name="contact_fax" id="contact_fax"
                           v-mask="['(###) ###-####', '(###) ###-#### ext. ####']"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>
            </div>


            <div class="row">
                <div class="col-sm-12  mt-4 mb-3">
                    <div class="text-xl text-grey-darkest mr-2 mb-2 mb-lg-0 block lg:inline w-full lg:w-auto">Project Data</div>
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="sales_statuses"> {{ getFieldLabel(fieldLabels, 'sales-status')}}</label>
                    <multiselect
                        v-model="form.sales_statuses"
                        :options="selects.sales_status"
                        label="full_description"
                        :multiple="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :close-on-select="false"
                        track-by="id"
                        id="sales_statuses"
                    />
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm"
                           for="marketing_status">{{ getFieldLabel(fieldLabels, 'marketing-status')}}</label>
                    <multiselect
                        v-model="form.marketing_statuses"
                        :options="selects.marketing_status"
                        label="full_description"
                        :multiple="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :close-on-select="false"
                        track-by="id"
                        id="marketing_status"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm">{{ getFieldLabel(fieldLabels, 'pre-bid')}}</label>
                    <div class="row">
                        <div class="col-6">
                            <datepicker v-model="form.pre_bid.start" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                        <div class="col-6">
                            <datepicker v-model="form.pre_bid.end" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm">{{ getFieldLabel(fieldLabels, 'bid-date')}}</label>
                    <div class="row">
                        <div class="col-6">
                            <datepicker v-model="form.bid_date.start" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                        <div class="col-6">
                            <datepicker v-model="form.bid_date.end" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm"
                           for="lead_from">{{ getFieldLabel(fieldLabels, 'lead-source')}}</label>
                    <multiselect
                        v-model="form.lead_froms"
                        :options="selects.lead_from"
                        label="full_description"
                        :multiple="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :close-on-select="false"
                        track-by="id"
                        id="lead_from"
                    />
<!--                    <select name="lead_from_id" id="lead_from_id" v-model="form.lead_from_id"-->
<!--                            class="appearance-none p-2 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-full">-->
<!--                        <option selected></option>-->
<!--                        <option v-for="item in selects.lead_from" :value="item.id">-->
<!--                            {{ item.full_description }}-->
<!--                        </option>-->
<!--                    </select>-->

                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="estimator">{{ getFieldLabel(fieldLabels, 'estimator')}}</label>
                    <multiselect
                        v-model="form.estimators"
                        :options="selects.users"
                        label="name"
                        :multiple="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :close-on-select="false"
                        track-by="id"
                        id="estimator"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm"
                           for="account_manager">{{ getFieldLabel(fieldLabels, 'account-manager')}}</label>
                    <multiselect
                        v-model="form.account_managers"
                        :options="selects.users"
                        label="name"
                        :multiple="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :close-on-select="false"
                        track-by="id"
                        id="account_manager"
                    />
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm"
                           for="take_off_person">{{ getFieldLabel(fieldLabels, 'take-off-person')}}</label>
                    <multiselect
                        v-model="form.take_off_persons"
                        :options="selects.users"
                        label="name"
                        :multiple="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :close-on-select="false"
                        track-by="id"
                        id="take_off_person"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm"
                           for="products_and_services">{{ getFieldLabel(fieldLabels, 'products-and-services')}}</label>
                    <multiselect
                        v-model="form.products_and_services"
                        :options="selects.products_and_services"
                        label="full_description"
                        :multiple="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :close-on-select="false"
                        track-by="id"
                        id="products_and_services"
                    />
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm"
                           for="client_profile">{{ getFieldLabel(fieldLabels, 'client-profile')}}</label>
                    <multiselect
                        v-model="form.client_profiles"
                        :options="selects.client_profile"
                        label="full_description"
                        :multiple="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :close-on-select="false"
                        track-by="id"
                        id="client_profile"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm"
                           for="contract_type">{{ getFieldLabel(fieldLabels, 'contract-type')}}</label>
                    <multiselect
                        v-model="form.contract_types"
                        :options="selects.contract_type"
                        label="full_description"
                        :multiple="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :close-on-select="false"
                        track-by="id"
                        id="contract_type"
                    />
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm"
                           for="office">{{ getFieldLabel(fieldLabels, 'office')}}</label>
                    <multiselect
                        v-model="form.offices"
                        :options="selects.office"
                        label="full_description"
                        :multiple="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :close-on-select="false"
                        track-by="id"
                        id="office"
                    />
                </div>
            </div>

            <!-- Custom Fields-->
            <div class="row" v-if="projectCustomFields.length > 0">
                <div class="col-sm-6 mb-3" v-for="(field, index) in projectCustomFields">

                    <label class="text-grey-darkest text-sm">{{ field.label_value }}</label>

                    <div v-if="field.options.length === 0 && field.type !== 4">
                        <input type="text" class="p-2 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-full" v-model="form.custom_fields[field.id]">
                    </div>
                    <div v-if="field.options.length == 0 && field.type === 4">
                        <datetime type="date"
                                  v-model="form.custom_fields[field.id]"
                                  :use-utc="true"
                                  :format="masks.date_mask"
                                  :week-start="7"
                                  class="p-2 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-full"/>
                    </div>
                    <div v-if="field.options.length > 0">
                        <multiselect v-model="form.custom_fields[field.id]"
                                     :id="field.name + '-' + field.id"
                                     :placeholder="'Select ' + field.name"
                                     :options="field.options"
                                     :multiple="true"
                                     track-by="id"
                                     label="name"
                                     value="id"
                                     :taggable="true"
                                     :close-on-select="true">
                        </multiselect>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12  mt-4 mb-3">
                    <div class="text-xl text-grey-darkest mr-2 mb-2 mb-lg-0 block lg:inline w-full lg:w-auto">Prequalifications</div>
                </div>
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm"
                           for="relate_and_connect_id">Relate & Connect</label>
                    <select name="relate_and_connect_id" id="relate_and_connect_id"
                            v-model="form.relate_and_connect_id"
                            class="appearance-none bg-white border-1 focus:outline-none p-2 rounded text-grey-darkest text-sm w-full">
                        <option selected></option>
                        <option v-for="item in selects.relate_and_connect" :value="item.id">{{
                                item.full_description
                            }}
                        </option>
                    </select>
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm"
                           for="rules_of_engagement_id">Rules of Engagement</label>
                    <select name="rules_of_engagement_id" id="rules_of_engagement_id"
                            v-model="form.rules_of_engagement_id"
                            class="appearance-none bg-white border-1 focus:outline-none p-2 rounded text-grey-darkest text-sm w-full">
                        <option selected></option>
                        <option v-for="item in selects.rules_of_engagement" :value="item.id">{{
                                item.full_description
                            }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm"
                           for="find_problems_id">Find Problems</label>
                    <select name="find_problems_id" id="find_problems_id"
                            v-model="form.find_problems_id"
                            class="appearance-none bg-white border-1 focus:outline-none p-2 rounded text-grey-darkest text-sm w-full">
                        <option selected></option>
                        <option v-for="item in selects.find_problems" :value="item.id">{{
                                item.full_description
                            }}
                        </option>
                    </select>
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="money_step_id">Money Step</label>
                    <select name="money_step_id" id="money_step_id"
                            v-model="form.money_step_id"
                            class="appearance-none bg-white border-1 focus:outline-none p-2 rounded text-grey-darkest text-sm w-full">
                        <option selected></option>
                        <option v-for="item in selects.money_step" :value="item.id">
                            {{ item.full_description }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm"
                           for="decision_process_id">Decision Process</label>
                    <select name="decision_process_id" id="decision_process_id"
                            v-model="form.decision_process_id"
                            class="appearance-none bg-white border-1 focus:outline-none p-2 rounded text-grey-darkest text-sm w-full">
                        <option selected></option>
                        <option v-for="item in selects.decision_process" :value="item.id">{{
                                item.full_description
                            }}
                        </option>
                    </select>
                </div>

                <div class="col-sm-6 mb-3">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12  mt-4 mb-3">
                    <div class="text-xl text-grey-darkest mr-2 mb-2 mb-lg-0 block lg:inline w-full lg:w-auto">Record Details</div>
                </div>
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="base_bid">Base Bid</label>
                    <currency-input
                        id="base_bid"
                        name="base_bid"
                        v-model="form.base_bid"
                        locale="us"
                        :currency="null"
                        class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                    </currency-input>
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="contract_amount">Contract Amount</label>
                    <currency-input
                        id="contract_amount"
                        name="contract_amount"
                        v-model="form.contract_amount"
                        locale="us"
                        :currency="null"
                        class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                    </currency-input>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm">Contract Dates</label>
                    <div class="row">
                        <div class="col-6">
                            <datepicker v-model="form.contract_date.start" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                        <div class="col-6">
                            <datepicker v-model="form.contract_date.end" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm">Login Dates</label>
                    <div class="row">
                        <div class="col-6">
                            <datepicker v-model="form.login_date.start" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                        <div class="col-6">
                            <datepicker v-model="form.login_date.end" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="gross_margin">Gross Margin %</label>
                    <currency-input
                        id="gross_margin"
                        name="gross_margin"
                        v-model="form.gross_margin"
                        locale="us"
                        :currency="null"
                        class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                    </currency-input>
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="labor_hours">Labor Hours</label>
                    <currency-input
                        id="labor_hours"
                        name="labor_hours"
                        v-model="form.labor_hours"
                        locale="us"
                        :currency="null"
                        class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                    </currency-input>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm">Dead Dates</label>
                    <div class="row">
                        <div class="col-6">
                            <datepicker v-model="form.dead_date.start" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                        <div class="col-6">
                            <datepicker v-model="form.dead_date.end" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12  mt-4 mb-3">
                    <div class="text-xl text-grey-darkest mr-2 mb-2 mb-lg-0 block lg:inline w-full lg:w-auto">Companies & Contacts</div>
                </div>
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm">Companies</label>
                    <multiselect
                        v-model="form.companies_id"
                        :options="companies"
                        label="name"
                        :multiple="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        @search-change="asyncFind"
                        :loading="isLoading"
                        track-by="id"
                        @input="selectedCompanies(false)"
                    />
                </div>
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm">Contacts</label>
                    <span v-if="contacts_data_loading" class="text-1xl text-grey-darkest text-center mt-32 ml-1">
                                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                            </span>
                    <multiselect
                        v-model="form.contact_ids"
                        :options="contacts"
                        label="name"
                        :multiple="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        track-by="id"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12  mt-4 mb-3">
                    <div class="text-xl text-grey-darkest mr-2 mb-2 mb-lg-0 block lg:inline w-full lg:w-auto">Comments</div>
                </div>
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm">Comments</label>
                    <b-form-textarea
                        id="textarea"
                        v-model="form.comment"
                        rows="3"
                        max-rows="6"
                    ></b-form-textarea>
                </div>
                <div class="col-sm-6 mb-3">

                </div>
            </div>

        </form>
    </div>
</template>
<script>

import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import {CurrencyInput} from "vue-currency-input";
import Form from "../../utils/form";
import Mixin from './mixin';

export default {
    name: 'list-project',
    props: ['masks', 'symbols', 'user', 'team', 'fieldLabels', 'listName', 'objectType', 'list'],
    components: {Datepicker, Multiselect, CurrencyInput},
    mixins: [Mixin],
    data() {
        return {
            form: new Form({
                id: null,
                list_name: this.listName,
                project_id: '',
                project_name: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                contact_name: '',
                contact_email: '',
                contact_phone: '',
                contact_cell: '',
                contact_fax: '',
                pre_bid: {start: '', end: ''},
                bid_date: {start: '', end: ''},
                relate_and_connect_id: 0,
                rules_of_engagement_id: 0,
                find_problems_id: 0,
                money_step_id: 0,
                decision_process_id: 0,
                base_bid: 0,
                contract_amount: 0,
                contract_date: {start: '', end: ''},
                login_date: {start: '', end: ''},
                gross_margin: 0,
                labor_hours: 0,
                dead_date: {start: '', end: ''},
                companies_id: [],
                contact_ids: [],
                comment: '',
                sales_statuses: null,
                marketing_statuses: null,
                lead_froms: null,
                estimators: null,
                account_managers: null,
                take_off_persons: null,
                products_and_services: null,
                client_profiles: null,
                contract_types: null,
                offices: null,
                object_type: 'project',
                custom_fields: {},
            }),

            companies: [],
            contacts: [],
            companiesSelected: [],
            new_view:'',
            showError:'',
            projectCustomFields: {},
            contacts_data_loading: false,
            selects: {
                sales_status: [],
                marketing_status: [],
                lead_from: [],
                users: [],
                products_and_services: [],
                client_profile:[],
                contract_type: [],
                office: [],
            },
            isLoading: false,
        }
    },
    watch: {
        listName: function(newVal, oldVal) {
            this.form.list_name = newVal
        },
        objectType: function(newVal, oldVal) {
            this.form.object_type = newVal
        }
    },
    created() {
        this.fetchCompanies();
        this.fetchCodes();
        this.fetchCustomFields();
        this.initForm();
    },
    methods: {
        fetchCodes() {
            axios.get(route('api.project.codes')).then(({data}) => {
                this.selects = data;
            });
        },
        fetchCompanies() {
            axios.get(route('api.project.companies')).then(({data}) => {
                this.companies = data.data;
            })
        },

        fetchCustomFields(){
            let self = this;
            axios.get(route('api.project-custom-field.index')+ '?project=true').then(({data}) => {
                self.projectCustomFields = data.data.sort((a,b) => a.label_order - b.label_order);
            });
        },

        selectedCompanies(isEditing = false) {
            const self = this;
            if(!isEditing) {
                self.form.contact_ids = [];
            }
            self.contacts_data_loading = true;

            let selectedCompanies = self.form.companies_id;
            let selectedCompanyIds = [];

            selectedCompanies.forEach(async (company) => {
                selectedCompanyIds.push(company.id);
            });

            if(selectedCompanyIds.length > 0) {
                axios.get(route('api.company.fetch-company-contacts', {company_ids: selectedCompanyIds})).then(({data}) => {
                    self.contacts = data;
                    self.contacts_data_loading = false;
                }).catch((error) => {
                    self.contacts_data_loading = false;
                    console.error('error', error);
                });
            } else {
                self.contacts_data_loading = false;
            }
        },
        asyncFind(query) {
            this.isLoading = true
            axios.get(route('api.company.filter-for-report', {query}
            )).then(({data}) => {
                this.companies = data;
                this.isLoading = false
            }).catch((error) => {
                this.isLoading = false
                console.log('error', error);
            });
        },
        saved() {
            this.saveList(this.form)
        },
        initForm() {
            if(!!this.list.filter){
                this.form = this.initListForm(this.list, this.listName );
                this.selectedCompanies(true);
            }
        },
        update() {
            this.updateList(this.form, this.list)
        }
    }
}
</script>
